import { apiBaseUrl } from "./api";
import { OfferApiError } from "./offerApi";
import { sessionExpired } from "./session";

// Focus tech (backend app/api/routes/focus_tech.py). Les erreurs gardent leur statut (409 : relire la version).
const request = async (endpoint, { method = "GET", body, form } = {}) => {
  const token = localStorage.getItem("auth_token");
  const response = await fetch(`${apiBaseUrl}${endpoint}`, {
    method,
    headers: {
      ...(form ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(form ? { body: form } : body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (response.status === 401) {
    sessionExpired();
    throw new OfferApiError(401, "Session expirée. Veuillez vous reconnecter.");
  }
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    let detail = data?.detail ?? "Une erreur est survenue";
    if (Array.isArray(detail)) detail = detail.map((entry) => entry?.msg || JSON.stringify(entry)).join(" ; ");
    throw new OfferApiError(response.status, detail);
  }
  return data;
};

// Les images d'un Focus s'écrivent « asset:CLÉ » dans le HTML ; la diapo (origine opaque) les charge par l'adresse
// publique de l'API.
export const assetUrl = (key) => `${apiBaseUrl}/focus-tech/files/${key}`;
export const withAssetUrls = (document) =>
  String(document || "").replace(/asset:([a-f0-9]{24})/g, (_, key) => assetUrl(key));

export const focusApi = {
  list: (scope = "mine") => request(`/focus-tech?scope=${encodeURIComponent(scope)}`),
  circles: () => request("/focus-tech/circles"),
  get: (id, revision) => request(`/focus-tech/${id}${revision ? `?revision=${revision}` : ""}`),
  create: (body) => request("/focus-tech", { method: "POST", body }),
  update: (id, body) => request(`/focus-tech/${id}`, { method: "PATCH", body }),
  remove: (id) => request(`/focus-tech/${id}`, { method: "DELETE" }),
  restore: (id, revision) => request(`/focus-tech/${id}/restore`, { method: "POST", body: { revision } }),
  reopen: (id) => request(`/focus-tech/${id}/reopen`, { method: "POST" }),
  assets: (id) => request(`/focus-tech/${id}/assets`),
  uploadAsset: (id, file) => {
    const form = new FormData();
    form.append("file", file);
    return request(`/focus-tech/${id}/assets`, { method: "POST", form });
  },
};
